import { batch, signal } from "@preact/signals-react"

export const announcements = signal([])
export const audiences = signal({ customers: [], users: [] })

export const isModalOpen = signal(false)
// null = creating a new one; an announcement row = editing that one.
export const editingAnnouncement = signal(null)

export const listFilters = signal({ customerID: null, userID: null, state: null })

export const openCreateModal = () => batch(() => {
    editingAnnouncement.value = null
    isModalOpen.value = true
})

export const openEditModal = announcement => batch(() => {
    editingAnnouncement.value = announcement
    isModalOpen.value = true
})

export const closeModal = () => batch(() => {
    isModalOpen.value = false
    editingAnnouncement.value = null
})

export const resetNewsManagement = () => batch(() => {
    announcements.value = []
    audiences.value = { customers: [], users: [] }
    isModalOpen.value = false
    editingAnnouncement.value = null
    listFilters.value = { customerID: null, userID: null, state: null }
})
